import { CommonUtilities } from '../../../commonUtils';

export default class systemListingService {

    static getSalesAnalysissales(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/sales?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static saveSalesAnalysissales(data: any) {
        var url = '/salesAnalysis/saveSalesAnalysis/'
        return CommonUtilities.postData(url, data);;
    }

    static getSalesAnalysismechanical(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/mechanical?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysispublishing(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/publishing?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysiscosts(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/costs?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysisadvances(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/advances?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getSalesAnalysislicensing(data: any) {
        var url = '/salesAnalysis/getSalesAnalysis/licensing?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getAllFormatCodeByParentGroup(data: any) {
        var url = 'release/getAllFormatCodeByParentGroup?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static FormatReleaseListing(data: any) {
        var url = 'release/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static MechanicalRateCount(data: any) {
        var url = 'contracts/mechRate/count?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static MechanicalRateListing(data: any) {
        var url = 'contracts/mechRate/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getAllClientZones(param: any) {
        var url = 'contracts/zones/getAllClientZones?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url);
    }

    static systemFormatsList() {
        var url = 'contracts/systemFormats?isPartFormatListed=true';
        return CommonUtilities.getData(url);
    }

    static classList(data: any) {
        var url = 'salesAnalysis/classlist/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static territoryList(data: any) {
        var url = 'systemListing/territory/territoryList?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static accountSubproviderList(data: any) {
        var url = 'systemListing/accountSubprovider/ASPlist?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractStatusList(data: any) {
        var url = 'contracts/contractStatus/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static projectStatusList(data: any) {
        var url = 'contracts/projectStatus/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusAccountList(data: any) {
        var url = 'common/statusAccount/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusAccountExtList(data: any) {
        var url = 'common/statusAccountExt/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusPayeeList(data: any) {
        var url = 'common/statusPayee/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusStatementList(data: any) {
        var url = 'common/statusStatement/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusProductList(data: any) {
        var url = 'common/statusProduct/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statusProductExtList(data: any) {
        var url = 'common/statusProductExt/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
}